module.exports = __webpack_public_path__ + "img/backlogo.a060b317.png";